import { render } from "./PublishEventBtn.vue?vue&type=template&id=7f4c449e"
import script from "./PublishEventBtn.vue?vue&type=script&lang=js"
export * from "./PublishEventBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__